import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@sm/intl';
import { Typography } from '@wds/typography';
const COPY = {
  TelephoneInputLabel: {
    id: 'buildWithAI.AnswersTelephone.TelephoneInputLabel',
    defaultMessage: '[Phone]',
    description: '[Type: Label][Vis.: high] - Label for phone number input'
  }
};
/**
 * Answer options for a telephone question, indicating a single phone number
 * input.
 */
const AnswersTelephone = () => _jsx(Typography, {
  component: "div",
  color: "darkMuted",
  variant: "body",
  children: t(COPY.TelephoneInputLabel)
});
export default AnswersTelephone;